import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { init, update } from "../../redux/actions/evaluationTerm";
import Footer from "../common/Footer";
import Header from "../common/Header";

export default function EvaluationPeriodChange() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const evaluationTerm = useSelector(state => state.evaluationTerm.row);

  useEffect(
    () => {
      dispatch(init());
    },
    [dispatch]
  );

  useEffect(
    () => {
      setRows(evaluationTerm);
    },
    [evaluationTerm]
  );

  const handleGridDataChange = params => {
    const { id, field, value } = params;

    setRows(prevData => {
      const newData = prevData.map(row => {
        if (row.id === id) {
          if (field === "startingDate") {
            const inputDate = new Date(value);

            const year = inputDate.getFullYear();
            const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // 月は0から始まるので+1し、2桁表示にする
            const day = String(inputDate.getDate()).padStart(2, "0"); // 日も2桁表示にする

            const formattedDate = `${year}-${month}-${day}`;
            return { ...row, [field]: formattedDate };
          }

          return { ...row, [field]: value };
        }
        return row;
      });
      return newData;
    });
  };

  const updateSubmit = () => {
    dispatch(update(rows));
  };

  const columns = [
    { field: "periodId", headerName: "期間ID", width: 150, editable: true, headerClassName: "headerColor", flex: 1 },
    { field: "periodName", headerName: "期間名", editable: true, width: 157, headerClassName: "headerColor", flex: 1 },
    {
      field: "startingDate",
      headerName: "開始日",
      type: "date",
      editable: true,
      width: 140,
      headerClassName: "headerColor",
      valueFormatter: params => {
        return params.value
          ? new Date(params.value).toLocaleDateString("ja-JP", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
          : "";
      },
      flex: 1
    },
    {
      field: "registeredDate",
      headerName: "登録日時",
      type: "dateTime",
      editable: false,
      width: 180,
      headerClassName: "headerColor",
      renderCell: params =>
        <div>
          {params.value
            ? new Date(params.value).toLocaleString("ja-JP", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              })
            : ""}
        </div>,
      flex: 1
    },
    {
      field: "updatedDate",
      headerName: "更新日時",
      type: "dateTime",
      editable: false,
      width: 180,
      headerClassName: "headerColor",
      renderCell: params =>
        <div>
          {params.value
            ? new Date(params.value).toLocaleString("ja-JP", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"
              })
            : ""}
        </div>,
      flex: 1
    }
  ];

  return (
    <Box>
      <Header />

      <Container>
        <Box
          sx={{
            marginTop: 4,
            marginBottom: 2,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            評価期間マスタ変更
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 1,
            alignItems: "left",
            justifyContent: "left"
          }}
        >
          <Typography component="h4" variant="h7" align="left" paddingLeft={2}>
            評価期間の登録または更新を行う
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 2 }}>
            <Container maxWidth="md">
              <div
                style={{
                  height: 330,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <DataGrid
                  sx={{
                    bgcolor: "white",
                    "& .headerColor": {
                      backgroundColor: "#ffcc80"
                    }
                  }}
                  rows={rows}
                  columns={columns}
                  hideFooter={true}
                  onCellEditCommit={handleGridDataChange}
                />
              </div>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" onClick={updateSubmit} sx={{ bgcolor: "#82b1ff", width: "50%" }}>
              更新
            </Button>
          </Stack>
        </Container>

        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href="/AdminMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}
